import React, { RefObject, useRef, useState } from 'react'
import className from 'classnames/bind'

import PureAudio from 'app/components/pure-audio/pure-audio.component'
import { PlaySoundIcon } from 'app/components/icons'
import { Button } from 'app/components/common'

import stylesModule from 'app/components/buttons/play-sound-button/play-sound-button.module.scss'
import MultimediaEventService from 'app/services/analitics/multimedia.event.service'
import { Sound } from 'app/components/sounds/types/sound'

const cx = className.bind(stylesModule)

type PlaySoundButtonProps = { sound: Sound }

const PlaySoundButton = ({ sound }: PlaySoundButtonProps) => {
  const [showPulse, setShowPulse] = useState(false)

  const audioRef = useRef<HTMLAudioElement | null>(null)

  function onSoundClick() {
    MultimediaEventService.sendPlaySoundEvent(sound.id, sound.name)
    audioRef.current?.play()
  }

  function setAudioRef(ref: RefObject<HTMLAudioElement>) {
    audioRef.current = ref.current
  }

  function onPlay() {
    setShowPulse(true)
  }

  function onEnded() {
    setShowPulse(false)
  }

  return (
    <>
      <div
        className={
          showPulse
            ? cx('play-sound-icon__pulse', 'play-sound-icon')
            : cx('play-sound-icon')
        }
      >
        <Button
          onClick={onSoundClick}
          className={cx('play-sound-icon__button')}
          aria-label={`Play sound ${sound.soundname}`}
          aria-pressed={showPulse}
        >
          <PlaySoundIcon className={cx('play-sound-icon__icon')} />
        </Button>
      </div>
      <PureAudio
        onAudioRef={setAudioRef}
        sources={sound.audioSources}
        onPlay={onPlay}
        onEnded={onEnded}
      />
    </>
  )
}

export default PlaySoundButton
